var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.169,
    height: 115.122,
    viewBox: "0 0 136.169 115.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_478533",
    "data-name": 478533,
    transform: "translate(0 -39.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_401",
    "data-name": "Grupo 401",
    transform: "translate(0 104.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_400",
    "data-name": "Grupo 400",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_216",
    "data-name": "Trazado 216",
    d: "M81.263,317H70.944a2.659,2.659,0,1,0,0,5.319H81.263a2.888,2.888,0,1,1,0,5.776H53.486a13.973,13.973,0,0,1-10.772-5.051l-6.643-7.984a19.269,19.269,0,0,0-14.3-6.953V292.4H31.56a18.447,18.447,0,0,1,12.874,5.2l14.337,13.839a2.613,2.613,0,0,1-3.58,3.806L43.935,304.925a2.659,2.659,0,1,0-3.594,3.92L51.6,319.163a7.931,7.931,0,0,0,10.867-11.552L48.128,293.772A23.74,23.74,0,0,0,31.56,287.08H21.252a6.6,6.6,0,0,0-6.075-4.034H2.659A2.659,2.659,0,0,0,0,285.705v19.446a2.659,2.659,0,1,0,5.319,0V288.364h9.859a1.275,1.275,0,0,1,1.273,1.273v21.314a1.275,1.275,0,0,1-1.273,1.273H12.415a2.659,2.659,0,1,0,0,5.319h2.762a6.6,6.6,0,0,0,6.113-4.131,13.972,13.972,0,0,1,10.692,5.049l6.643,7.985a19.277,19.277,0,0,0,14.861,6.968H81.263a8.207,8.207,0,1,0,0-16.413Z",
    transform: "translate(0 -283.046)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_403",
    "data-name": "Grupo 403",
    transform: "translate(46.699 39.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_402",
    "data-name": "Grupo 402",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_217",
    "data-name": "Trazado 217",
    d: "M262.4,64.133a2.659,2.659,0,0,0-2.659,2.659V84.618h-9.859a1.275,1.275,0,0,1-1.273-1.273V62.031a1.275,1.275,0,0,1,1.273-1.273h2.567a2.659,2.659,0,0,0,0-5.319h-2.567a6.6,6.6,0,0,0-6.113,4.131,13.972,13.972,0,0,1-10.692-5.049l-6.643-7.984a19.277,19.277,0,0,0-14.861-6.968H183.8a8.206,8.206,0,1,0,0,16.413h11.358a2.659,2.659,0,0,0,0-5.319H183.8a2.888,2.888,0,1,1,0-5.776h27.777a13.973,13.973,0,0,1,10.773,5.051l6.643,7.984a19.269,19.269,0,0,0,14.3,6.953V80.583H233.5a18.447,18.447,0,0,1-12.874-5.2L206.288,61.544a2.613,2.613,0,0,1,3.58-3.806l11.256,10.318a2.659,2.659,0,1,0,3.594-3.92L213.462,53.819a7.931,7.931,0,0,0-10.867,11.552L216.932,79.21A23.74,23.74,0,0,0,233.5,85.9h10.308a6.6,6.6,0,0,0,6.075,4.034H262.4a2.659,2.659,0,0,0,2.659-2.659V66.792A2.66,2.66,0,0,0,262.4,64.133Z",
    transform: "translate(-175.59 -39.568)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_405",
    "data-name": "Grupo 405",
    transform: "translate(80.748 128.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_404",
    "data-name": "Grupo 404",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_218",
    "data-name": "Trazado 218",
    d: "M308.729,375.318a2.686,2.686,0,1,0-1.39,3.545l.057-.025A2.663,2.663,0,0,0,308.729,375.318Z",
    transform: "translate(-303.617 -373.752)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_407",
    "data-name": "Grupo 407",
    transform: "translate(87.66 124.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_406",
    "data-name": "Grupo 406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_219",
    "data-name": "Trazado 219",
    d: "M334.414,359.835a2.669,2.669,0,1,0-.581,3.73l.033-.024A2.648,2.648,0,0,0,334.414,359.835Z",
    transform: "translate(-329.603 -358.757)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_409",
    "data-name": "Grupo 409",
    transform: "translate(73.142 130.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_408",
    "data-name": "Grupo 408",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220",
    "data-name": "Trazado 220",
    d: "M280.3,385.048a2.683,2.683,0,1,0-2.125,3.167l.078-.016A2.656,2.656,0,0,0,280.3,385.048Z",
    transform: "translate(-275.016 -382.94)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_411",
    "data-name": "Grupo 411",
    transform: "translate(93.568 119.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_410",
    "data-name": "Grupo 410",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    d: "M356.277,339.172a2.659,2.659,0,0,0-3.756.194l-.056.064a2.659,2.659,0,1,0,3.812-.257Zm-1.485,2.242-.3-.268.32.289Z",
    transform: "translate(-351.819 -338.487)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_413",
    "data-name": "Grupo 413",
    transform: "translate(101.358 105.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_412",
    "data-name": "Grupo 412",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_222",
    "data-name": "Trazado 222",
    d: "M384.546,286.557a2.671,2.671,0,1,0,1.765,3.345l.011-.036A2.653,2.653,0,0,0,384.546,286.557Z",
    transform: "translate(-381.109 -286.442)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_415",
    "data-name": "Grupo 415",
    transform: "translate(102.919 89.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_414",
    "data-name": "Grupo 414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_223",
    "data-name": "Trazado 223",
    d: "M392.261,229.154c-.006-.034-.012-.068-.019-.1a2.679,2.679,0,1,0,.019.1Z",
    transform: "translate(-386.979 -226.939)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_417",
    "data-name": "Grupo 417",
    transform: "translate(102.867 97.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_416",
    "data-name": "Grupo 416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_224",
    "data-name": "Trazado 224",
    d: "M389.678,256.933a2.662,2.662,0,0,0-2.882,2.415c0,.026-.006.078-.008.1a2.659,2.659,0,0,0,2.5,2.811c.053,0,.106,0,.158,0a2.673,2.673,0,0,0,.233-5.335Z",
    transform: "translate(-386.783 -256.923)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_419",
    "data-name": "Grupo 419",
    transform: "translate(98.206 112.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_418",
    "data-name": "Grupo 418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_225",
    "data-name": "Trazado 225",
    d: "M373.244,314.37a2.66,2.66,0,0,0-3.624,1l-.037.066a2.664,2.664,0,0,0,2.337,3.942A2.638,2.638,0,0,0,374.244,318l-2.312-1.314,2.314,1.311A2.659,2.659,0,0,0,373.244,314.37Z",
    transform: "translate(-369.259 -314.024)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_421",
    "data-name": "Grupo 421",
    transform: "translate(48.908 60.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_420",
    "data-name": "Grupo 420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_226",
    "data-name": "Trazado 226",
    d: "M188.95,120.84a2.659,2.659,0,0,0-3.568-1.189l-.024.012a2.659,2.659,0,1,0,3.591,1.178Z",
    transform: "translate(-183.898 -119.37)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_423",
    "data-name": "Grupo 423",
    transform: "translate(56.379 58.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_422",
    "data-name": "Grupo 422",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_227",
    "data-name": "Trazado 227",
    d: "M217.262,110.951a2.659,2.659,0,0,0-3.211-1.958l-.062.016a2.659,2.659,0,1,0,3.273,1.942Z",
    transform: "translate(-211.987 -108.918)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425",
    transform: "translate(42.18 65.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_424",
    "data-name": "Grupo 424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_228",
    "data-name": "Trazado 228",
    d: "M163.348,136.585a2.663,2.663,0,0,0-3.738-.4l1.649,2.086-1.657-2.08a2.659,2.659,0,0,0,3.313,4.161l.035-.028A2.656,2.656,0,0,0,163.348,136.585Z",
    transform: "translate(-158.599 -135.595)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_427",
    "data-name": "Grupo 427",
    transform: "translate(29.384 84.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_426",
    "data-name": "Grupo 426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_229",
    "data-name": "Trazado 229",
    d: "M113.853,210.2a2.659,2.659,0,0,0-3.265,1.866c-.007.024-.019.074-.026.1a2.66,2.66,0,1,0,3.291-1.965Z",
    transform: "translate(-110.487 -210.106)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_429",
    "data-name": "Grupo 429",
    transform: "translate(28.242 92.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_428",
    "data-name": "Grupo 428",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_230",
    "data-name": "Trazado 230",
    d: "M109.005,239.828a2.66,2.66,0,0,0-2.809,2.5c0,.034,0,.068,0,.1a2.658,2.658,0,0,0,2.579,2.734h.081a2.672,2.672,0,0,0,.154-5.339Z",
    transform: "translate(-106.191 -239.824)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_431",
    "data-name": "Grupo 431",
    transform: "translate(32.19 77.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_430",
    "data-name": "Grupo 430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_231",
    "data-name": "Trazado 231",
    d: "M124.944,182.294a2.659,2.659,0,0,0-3.59,1.119l-.043.086a2.659,2.659,0,1,0,3.633-1.205Z",
    transform: "translate(-121.037 -181.989)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_433",
    "data-name": "Grupo 433",
    transform: "translate(36.526 70.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_432",
    "data-name": "Grupo 432",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_232",
    "data-name": "Trazado 232",
    d: "M141.713,157.387a2.659,2.659,0,0,0-3.745.347l-.055.068a2.659,2.659,0,1,0,3.8-.415Z",
    transform: "translate(-137.339 -156.773)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_435",
    "data-name": "Grupo 435",
    transform: "translate(28.784 100.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_434",
    "data-name": "Grupo 434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_233",
    "data-name": "Trazado 233",
    d: "M113.507,271.981a2.659,2.659,0,0,0-5.235.938l0,.026a2.645,2.645,0,0,0,2.607,2.178,2.7,2.7,0,0,0,.477-.043A2.67,2.67,0,0,0,113.507,271.981Z",
    transform: "translate(-108.23 -269.791)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_437",
    "data-name": "Grupo 437",
    transform: "translate(46.959 82.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_436",
    "data-name": "Grupo 436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_234",
    "data-name": "Trazado 234",
    d: "M206.823,202.125a12.315,12.315,0,0,0-8.954,3.836,12.351,12.351,0,1,0-16.857,18l.052.043,15.154,12a2.659,2.659,0,0,0,3.307-.005l15.8-12.582a2.634,2.634,0,0,0,.221-.2,12.348,12.348,0,0,0-8.72-21.092Zm5.061,17.229-14.019,11.167-13.471-10.665a7.03,7.03,0,1,1,11.019-8.071,2.659,2.659,0,0,0,4.913,0,7.031,7.031,0,1,1,11.558,7.569Z",
    transform: "translate(-176.566 -202.125)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_439",
    "data-name": "Grupo 439",
    transform: "translate(0.009 133.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_438",
    "data-name": "Grupo 438"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 2.65,
    cy: 2.65,
    r: 2.65,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_441",
    "data-name": "Grupo 441",
    transform: "translate(130.859 55.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_440",
    "data-name": "Grupo 440"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 2.65,
    cy: 2.65,
    r: 2.65,
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.33943a78f6840ff0f6d66b48d24e40a0.svg";
export { ForwardRef as ReactComponent };